import React from 'react';
import PropTypes from 'prop-types';

function Image({ alt, className, src }) {
  return (
    <img alt={alt} className={className} src={src} />
  );
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  src: PropTypes.string.isRequired
};

Image.defaultProps = {
  alt: null,
  className: null,
};

export default Image;
